import { Checkbox, DatePicker, Form, Input, TimePicker } from "antd";
import { Container } from "../../../../common/components/container/Container";
import { GoBack } from "../../../../common/components/GoBack/GoBack";
import { FormProvider } from "../../../../common/provider/form/Form.provider";
import style from "./style.module.scss";
import { SimpleInput } from "../../../../common/components/simpleInput";
import { useState } from "react";
import "./style.scss";
import { CustomButton } from "../../../../common/components/CustomButton/CustomButton";
import { useLocation, useNavigate } from "react-router";
// import { UploadInputFile } from "../../../../common/components/Upload/UploadInputFile";
import Spinner from "../../../../common/components/Spinner/Spinner";
import { CommercialOperation } from "../../core/_request";
// import { createFormData } from "../../../../utilities/formData";
// import { API_BASE_URL } from "../../../../utilities/API_CONSTANT";
// import { AiOutlineCloudDownload } from "react-icons/ai";
import { HttpStatusCode } from "axios";
import { OperationType } from "../../core/_context";
import { InputSelect } from "../../../../common/components/InputSelect/InputSelect";
import { API_URLs } from "../../../../utilities/API_URLs";
import dayjs from "dayjs";
import { buildLoads } from "../../core/_buildLoads";
import { OperationBlock } from "./components/OperationBlock";

/* const STATIC_FILES_NAME = {
  MANIFESTE: "manifestFile",
  COMMANDE_PJ: "teamOrderFile",
  AVIS_PJ: "arrivalNoticeFile",
  LANDING: "mscDebarkationFile",
  EMPTY_BOARDING: "mscEmptyEmbarkationFile",
  FULL_BOARDING: "mscFullEmbarkationFile",
}; */

type PropsType = {
  operationType?: OperationType;
};

export const BasicInformation = ({ operationType = "unknown" }: PropsType) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);

  const location = useLocation();
  const isSales = location.pathname.includes("/sales-operations");

  const [selectedOperationType, setSelectedOperationType] = useState<
    string | null
  >(null);

  /* const [sectionErrors, setSectionErrors] = useState<{
    embarkation?: boolean;
    debarkation?: boolean;
  }>({}); */

  const isEmbarkation = selectedOperationType === "EMBARKATION";
  const isDebarkation = selectedOperationType === "DEBARKATION";
  const isBoth = selectedOperationType === "EMBARKATION_DEBARKATION";

  const [checked, setChecked] = useState<boolean>(false); 
  const [showCheckbox, setShowCheckbox] = useState<boolean>(false);

  const [vehicleExternalParts, setVehicleExternalParts] = useState<any[]>([]);
  const [vehicleInternalParts, setVehicleInternalParts] = useState<any[]>([]);
  const [validationTick, setValidationTick] = useState(0);

  const onHandleChecked = () => {
    setChecked((prev: any) => !prev);
  }

  

  const handleSubmiFile = async (values: any) => {
    try {
      setIsLoadingSubmit(true);

      /* const dataToPost = {
        ...values,
        operationCategory: isSales ? "COMMERCIAL" : "CABOTAGE",

        // Toujours envoyés
        [STATIC_FILES_NAME.COMMANDE_PJ]:
          values?.[STATIC_FILES_NAME.COMMANDE_PJ]?.[0]?.originFileObj,
        [STATIC_FILES_NAME.AVIS_PJ]:
          values?.[STATIC_FILES_NAME.AVIS_PJ]?.[0]?.originFileObj,

        // Non MSC
        ...(!checked && {
          [STATIC_FILES_NAME.MANIFESTE]:
            values?.[STATIC_FILES_NAME.MANIFESTE]?.[0]?.originFileObj,
        }),

        // MSC uniquement
        ...(checked && {
          isMsc: 1,
          ...(values?.[STATIC_FILES_NAME.LANDING]?.[0]?.originFileObj && {
            [STATIC_FILES_NAME.LANDING]:
              values[STATIC_FILES_NAME.LANDING][0].originFileObj,
          }),

          ...(values?.[STATIC_FILES_NAME.EMPTY_BOARDING]?.[0]
            ?.originFileObj && {
            [STATIC_FILES_NAME.EMPTY_BOARDING]:
              values[STATIC_FILES_NAME.EMPTY_BOARDING][0].originFileObj,
          }),

          ...(values?.[STATIC_FILES_NAME.FULL_BOARDING]?.[0]?.originFileObj && {
            [STATIC_FILES_NAME.FULL_BOARDING]:
              values[STATIC_FILES_NAME.FULL_BOARDING][0].originFileObj,
          }),
        }),
      }; */

      const { debarkation, embarkation, estimatedArrivalHour, estimatedDepartureHour, estimatedOperationSartHour, ...rest } = values;

      const debarkationLoads = buildLoads(
        values.debarkation,
        vehicleExternalParts,
        vehicleInternalParts
      );
      
      const embarkationLoads = buildLoads(
        values.embarkation,
        vehicleExternalParts,
        vehicleInternalParts
      );

      const dataToPost = {
        ...rest,
        operationCategory: operationType === "cabotage" ? "/api/operation_categories/CABOTAGE" : "/api/operation_categories/COMMERCIAL",
        customer: values?.customer ? values?.customer?.value : null,
        estimatedArrivalAt:
        values?.estimatedArrivalAt && values?.estimatedArrivalHour
          ? dayjs(values.estimatedArrivalAt)
              .hour(dayjs(values.estimatedArrivalHour).hour())
              .minute(dayjs(values.estimatedArrivalHour).minute())
              .format("DD/MM/YYYY HH:mm")
          : null,  
        estimatedDepartureAt:
        values?.estimatedDepartureAt && values?.estimatedDepartureHour
          ? dayjs(values.estimatedDepartureAt)
              .hour(dayjs(values.estimatedDepartureHour).hour())
              .minute(dayjs(values.estimatedDepartureHour).minute())
              .format("DD/MM/YYYY HH:mm")
          : null,  
          estimatedOperationsStartAt:
        values?.estimatedOperationsStartAt && values?.estimatedOperationSartHour
          ? dayjs(values.estimatedOperationsStartAt)
              .hour(dayjs(values.estimatedOperationSartHour).hour())
              .minute(dayjs(values.estimatedOperationSartHour).minute())
              .format("DD/MM/YYYY HH:mm")
          : null,  
        fillManifestDirectly: checked,     
        operationType: values?.operationType ? `/api/operation_types/${values?.operationType?.value}`: null,
        ...((isDebarkation || isBoth) &&
          checked &&
          debarkationLoads.length > 0
          ? {
              debarkationMovement: {
                loads: debarkationLoads,
              },
            }
          : {}),

        ...((isEmbarkation || isBoth) &&
          checked &&
          embarkationLoads.length > 0
          ? {
              embarkationMovement: {
                loads: embarkationLoads,
              },
            }
          : {}),
      }

      const res = await CommercialOperation.createOperations(dataToPost);

      // JSON.stringify(console.log("payload: ", dataToPost));

      if (res?.status === HttpStatusCode.Ok || res?.status === HttpStatusCode.Created) {
        const newPath = isSales
          ? `/app/operations/sales-operations/operation/${res?.data?.id}`
          : `/app/operations/cabotage/operation/${res?.data?.id}`;

        navigate(newPath);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  return (
    <div className={style.basic}>
      <div className={style.basic__header}>
        <GoBack />
        <div>
          <span>
            Nouvelle opération {isSales ? "commerciale" : "de cabotage"}
          </span>
        </div>
      </div>
      <Container>
        <div className="">
          <p className={style.basic__title}>Informations de la demande</p>
        </div>

        <FormProvider
          Form={Form}
          form={form}
          debug
          onFieldsChange={() => {
            setValidationTick((prev) => prev + 1);
          }}
          onFinish={(values) => {
            const hasEmbarkation =
              values?.embarkation?.containers?.length ||
              values?.embarkation?.bags?.length ||
              values?.embarkation?.vehicles?.length ||
              values?.embarkation?.crafts?.length ||
              values?.embarkation?.others?.length;

            const hasDebarkation =
              values?.debarkation?.containers?.length ||
              values?.debarkation?.bags?.length ||
              values?.debarkation?.vehicles?.length ||
              values?.debarkation?.crafts?.length ||
              values?.debarkation?.others?.length;

            const errors: any = {};

            if (checked) {
              if (isBoth) {
                if (!hasEmbarkation && !hasDebarkation) {
                  errors.debarkation = true;
                }
              } else {
                if (isEmbarkation && !hasEmbarkation) {
                  errors.embarkation = true;
                }
              
                if (isDebarkation && !hasDebarkation) {
                  errors.debarkation = true;
                }
              }
            }

            // 👉 S'il y a au moins une erreur → stop
            /* if (Object.keys(errors).length > 0) {
              //setSectionErrors(errors);
              return;
            } */

            // reset erreurs si tout est OK
            //setSectionErrors({});
            handleSubmiFile(values);
          }}
          onFinishFailed={(err) => {
            console.log("err", err);
            setValidationTick((prev) => prev + 1);
          }}
        >
          <div className={style.basic__form_container}>
          <div className={`${style.basic__form_first_content} ${style.basic__form_first_content_responsive}`}>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={`${
                    operationType === "cabotage" ? "reference" : "travelReference"
                  }`}
                  label={`Référence ${operationType === "cabotage" ? "commande Équipe" : "du voyage"}`}
                  rules={[
                    {
                      required: true,
                      message: "Champ requis",
                    },
                  ]}
                  customInput={<Input />}
                />
              </div>
            </div>
          <div className={`${style.basic__form_first_content} ${style.basic__form_first_content_responsive}`}>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={"origin"}
                  label={"Port de provenance"}
                  rules={[
                    {
                      required: true,
                      message: "Champ requis",
                    },
                  ]}
                  customInput={<Input />}
                />
              </div>
              <div style={{flex: 1, marginTop: "20px", display: "flex", flexDirection: "row", gap: 10}}>
                <div  style={{ flex: 3/4 }}>
                <SimpleInput
                  Form={Form}
                  name={"estimatedDepartureAt"}
                  label="ETD (jour)"
                  rules={[
                    {
                      required: true,
                      message: "Champ requis",
                    },
                  ]}
                  customInput={<DatePicker className="w-100"/>}
                />
                </div>
                <div  style={{ flex: 1/4 }}>
                <SimpleInput
                  Form={Form}
                  label="(heure)"
                  name={"estimatedDepartureHour"}
                  rules={[
                    {
                      required: true,
                      message: `Champ requis`,
                    },
                  ]}
                  customInput={
                    <TimePicker
                      style={{ width: "100%" }}
                      needConfirm={false}
                      format={"HH:mm"}
                      showNow={false}
                    />
                  }
                />
                </div> 
              </div>
            </div>
          <div className={`${style.basic__form_first_content} ${style.basic__form_first_content_responsive}`}>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={"destination"}
                  label={"Port de destination"}
                  rules={[
                    {
                      required: true,
                      message: "Champ requis",
                    },
                  ]}
                  customInput={<Input />}
                />
              </div>
              <div style={{flex: 1, marginTop: "20px", display: "flex", flexDirection: "row", gap: 10}}>
                <div  style={{ flex: 3/4 }}>
                <SimpleInput
                  Form={Form}
                  name={"estimatedArrivalAt"}
                  label="ETA (jour)"
                  rules={[
                    {
                      required: true,
                      message: "Champ requis",
                    },
                  ]}
                  customInput={<DatePicker className="w-100"/>}
                />
                </div>
                <div  style={{ flex: 1/4 }}>
                <SimpleInput
                  Form={Form}
                  label="(heure)"
                  name={"estimatedArrivalHour"}
                  rules={[
                    {
                      required: true,
                      message: `Champ requis`,
                    },
                  ]}
                  customInput={
                    <TimePicker
                      style={{ width: "100%" }}
                      needConfirm={false}
                      format={"HH:mm"}
                      showNow={false}
                    />
                  }
                />
                </div> 
              </div>
            </div>
          <div className={`${style.basic__form_first_content} ${style.basic__form_first_content_responsive}`}>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={"secondaryDestination"}
                  label={"Second port de destination"}
                  customInput={<Input />}
                />
              </div>
              <div className={style.basic__form_first_content_item}></div>
            </div>
          <div className={`${style.basic__form_first_content} ${style.basic__form_first_content_responsive}`}>
              
              <div style={{flex: 1, marginTop: "20px", display: "flex", flexDirection: "row", gap: 10}}>
                <div  style={{ flex: 3/4 }}>
                <SimpleInput
                  Form={Form}
                  name={"estimatedOperationsStartAt"}
                  label="Début d'operation estimé (jour)"
                  rules={[
                    {
                      required: true,
                      message: "Champ requis",
                    },
                  ]}
                  customInput={<DatePicker className="w-100"/>}
                />
                </div>
                <div  style={{ flex: 1/4 }}>
                <SimpleInput
                  Form={Form}
                  label="(heure)"
                  name={"estimatedOperationSartHour"}
                  rules={[
                    {
                      required: true,
                      message: `Champ requis`,
                    },
                  ]}
                  customInput={
                    <TimePicker
                      style={{ width: "100%" }}
                      needConfirm={false}
                      format={"HH:mm"}
                      showNow={false}
                    />
                  }
                />
                </div> 
              </div>
              <div className={style.basic__form_first_content_item}>
              </div>
            </div>
            <div className={style.basic__form_first_content}>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={"ship"}
                  label="Navire"
                  rules={[
                    {
                      required: true,
                      message: "Champ requis",
                    },
                  ]}
                  customInput={<Input />}
                />
              </div>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={"customer"}
                  label="Client"
                  rules={[
                    {
                      required: true,
                      message: "Champ requis",
                    },
                  ]}
                  customInput={<InputSelect onChange={() => {}} uri={API_URLs.settings.customers.getCustomerSelect} />}
                />
              </div>
            </div>
            {operationType === "cabotage" ? (
              <>
                <div className={style.basic__form_first_content}>
                  <div className={style.basic__form_first_content_item}>
                    <SimpleInput
                      Form={Form}
                      name={"operationType"}
                      label="Type d'opération"
                      rules={[
                        {
                          required: true,
                          message: "Champ requis",
                        },
                      ]}
                      customInput={
                        <InputSelect
                          uri="api/operation_types/select"
                          isNotUri
                          onChange={(e) => {
                            setSelectedOperationType(e?.value);
                            setShowCheckbox(e?.value);
                          }}
                        />
                      }
                    />
                  </div>
                </div>

                {/* TEXT CONDITIONNING OPERATION BLOCK SECTION DISPLAY */}
                {
                  showCheckbox ? <Checkbox className={style.msc_text} checked={checked} onClick={onHandleChecked}>Renseigner le manifeste</Checkbox> : ""
                }

                {/* LOADS ACCORDING TO OPERATION TYPE */}

                {((isDebarkation || isBoth) && checked) && (
                  <OperationBlock
                  title="DÉBARQUEMENT"
                  prefix="debarkation"
                  form={form}
                  // sectionErrors={sectionErrors}
                  validationTick={validationTick}
                  setVehicleExternalParts={setVehicleExternalParts}
                  setVehicleInternalParts={setVehicleInternalParts}
                />
                )}

                {((isEmbarkation || isBoth) && checked) && (
                  <OperationBlock
                  title="EMBARQUEMENT"
                  prefix="embarkation"
                  form={form}
                  // sectionErrors={sectionErrors}
                  validationTick={validationTick}
                  setVehicleExternalParts={setVehicleExternalParts}
                  setVehicleInternalParts={setVehicleInternalParts}
                />
                )}
              </>
            ) : (
              ""
            )}
            {/* FIRST LINE : Résumé commercial, Pièce jointe CÉ, Pièce jointe AA */}
            {/* <div className={style.basic__form_first_content}>
              { !checked && (
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={STATIC_FILES_NAME.MANIFESTE}
                  label={`${
                    operationType === "cabotage"
                      ? "Manifeste"
                      : "Résumé commercial"
                  } `}
                  rules={[
                    {
                      required: true,
                      message: "Champ requis",
                    },
                  ]}
                  customInput={<UploadInputFile isExcelOnly />}
                />
                <div className={style.basic__link_wrapper}>
                  <a
                    href={
                      isSales
                        ? `${API_BASE_URL}/templates/resume_commercial.xlsx`
                        : `${API_BASE_URL}/templates/manifeste.xlsx`
                    }
                    download
                    target="_blank"
                    className={style.basic__link}
                  >
                    <AiOutlineCloudDownload
                      className={style.basic__link_icon}
                    />{" "}
                    Télécharger le modèle
                  </a>
                </div>
              </div>)}
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={STATIC_FILES_NAME.COMMANDE_PJ}
                  label="Pièce jointe (commande équipe)"
                  rules={[
                    {
                      required: true,
                      message: "Champ requis",
                    },
                  ]}
                  customInput={<UploadInputFile isExcelOnly />}
                />
                <div className={style.basic__link_wrapper}>
                  <a
                    href={
                      isSales
                        ? `${API_BASE_URL}/templates/commande_equipe_commercial.xlsx`
                        : `${API_BASE_URL}/templates/commande_equipe_cabotage.xlsx`
                    }
                    download
                    target="_blank"
                    className={style.basic__link}
                  >
                    <AiOutlineCloudDownload
                      className={style.basic__link_icon}
                    />{" "}
                    Télécharger le modèle
                  </a>
                </div>
              </div>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={STATIC_FILES_NAME.AVIS_PJ}
                  label="Pièce jointe (Avis d'arrivée)"
                  rules={[
                    {
                      required: true,
                      message: "Champ requis",
                    },
                  ]}
                  customInput={<UploadInputFile isExcelOnly />}
                />
                <div className={style.basic__link_wrapper}>
                  <a
                    href={
                      isSales
                        ? `${API_BASE_URL}/templates/avis_arrivee_commercial.xlsx`
                        : `${API_BASE_URL}/templates/avis_arrivee_cabotage.xlsx`
                    }
                    download
                    target="_blank"
                    className={style.basic__link}
                  >
                    <AiOutlineCloudDownload
                      className={style.basic__link_icon}
                    />{" "}
                    Télécharger le modèle
                  </a>
                </div>
              </div>
              { checked && (<div className={style.basic__form_first_content_item}>
                
              </div>)}
            </div> */}
            {/* CHAMPS MSC */}
            {/* isSales && (
            <Checkbox className={style.msc_text} onChange={onChecked}>Importer des fichiers MSC</Checkbox>
          ) */}
            {/* checked && (<div className={style.basic__form_first_content}>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={STATIC_FILES_NAME.LANDING}
                  label={"Ficher de débarquement"}
                  customInput={<UploadInputFile isExcelOnly />}
                />
              </div>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={STATIC_FILES_NAME.EMPTY_BOARDING}
                  label="Fichier d'embarquement vide"
                  customInput={<UploadInputFile isExcelOnly />}
                />
              </div>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={STATIC_FILES_NAME.FULL_BOARDING}
                  label="Fichier d'embarquement plein"
                  customInput={<UploadInputFile isExcelOnly />}
                />
              </div>
            </div>)*/}
            {/* NOTES */}
            {/* <div className={style.basic__form_first_content}>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={"notes"}
                  label="Notes"
                  customInput={<TextArea rows={6} />}
                />
              </div>
            </div> */}
          </div>
          {/* BOUTON */}
          <div className={style.basic__footer}>
            <CustomButton
              backgroundColor="#72A4FC"
              className={style.basic__footer_button}
            >
              {isLoadingSubmit ? <Spinner /> : <span>Créer opération </span>}
            </CustomButton>
          </div>
        </FormProvider>
      </Container>
    </div>
  );
};
